<template>
  <div class="complete_wrap">
    <div class="content_wrap" :class="{'waiting-queue': waitingParams.queueIndex !== -1}">
      <div class="description_wrap">
        <div class="img_wrap">
          <div class="img" :class="iconType"></div>
        </div>
        <div class="title" v-html="message"></div>
        <div class="description" v-html="displayDescription"></div>
        <button class="go_home_button" @click="goHome">{{ $tc('complete_03_goHome') }}</button>
      </div>
      <div class="ticket_wrap">
        <div class="ticket-title">{{ $tc('complete_05_waitingNumber') }}</div>
        <div class="waiting-queue-name" v-if="waitingParams.queueIndex !== -1">{{ displayQueueName }}</div>
        <div class="waiting-number">{{ watingNum }}</div>
      </div>
    </div>
    <div class="timer_text" v-html="timerText"></div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { getMultiLanguageName } from '../utills'

export default {
  name: 'CompleteView',
  props: ['watingNum'],
  computed: {
    ...mapState(['restaurant', 'locale']),
    ...mapGetters({ waitingParams: 'getWaitingParams' }),
    isProduction () {
      return process.env.NODE_ENV === 'production'
    },
    timerText () {
      return this.$tc('complete_04_automaticallyMove', this.countDown)
    },
    displayQueueName () {
      const queueData = {
        name: this.waitingParams.queueName,
        multiLanguage: { name: this.waitingParams.queueNameMultiLanguage }
      }
      return getMultiLanguageName(queueData, this.locale)
    },
    isEmail () {
      return (this.locale !== 'ko' && this.restaurant.foreignRequestType && this.restaurant.foreignRequestType.length > 0 && this.waitingParams.email !== '')
    },
    isLine () {
      return (this.locale !== 'ko' && this.restaurant.foreignRequestType && this.restaurant.foreignRequestType.length > 0 && this.waitingParams.tempKey !== '')
    },
    // 알림수단 아이콘 우선순위: 접수 수단(line/email) > 매장 설정(ticket/camera/katalk)
    iconType () {
      if (this.isLine) return 'line'
      if (this.isEmail) return 'email'
      if (this.isTicket) return 'ticket'
      if (this.isCamera) return 'camera'
      if (this.isKatalk) return 'katalk'
      return ''
    },
    displayDescription () {
      if (this.isLine) return this.$tc('complete_02_alarmInfo_for_line')
      return this.isCamera ? this.$tc('complete_02_alarmInfo_for_camera') : this.$tc('complete_02_alarmInfo')
    },
    isTicket () {
      return (!this.restaurant.phoneRequired || (this.restaurant.phoneRequired && this.waitingParams.isNoPhone) || this.locale !== 'ko') && this.restaurant.isNumTicket
    },
    isCamera () {
      return (!this.restaurant.phoneRequired || (this.restaurant.phoneRequired && this.waitingParams.isNoPhone)) && !this.restaurant.isNumTicket
    },
    isKatalk () {
      return !this.isTicket && this.restaurant.phoneRequired && !this.waitingParams.isNoPhone
    },
    message () {
      switch (this.iconType) {
        case 'line': return this.$tc('checkLine')
        case 'email': return this.$tc('complete_01_check_email')
        case 'ticket': return this.$tc('keepNumberTicket')
        case 'camera': return this.$tc('readyToPhone')
        case 'katalk': return this.$tc('checkKakaotalk')
        default: return ''
      }
    }
  },
  data () {
    return {
      timeoutObj: {},
      countDown: 5
    }
  },
  methods: {
    goHome () {
      clearTimeout(this.timeoutObj)
      this.$router.push('/')
    },
    countDownTimer () {
      // if (!this.isProduction) {
      //   return
      // }
      if (this.countDown > 0) {
        this.timeoutObj = setTimeout(() => {
          this.countDown -= 1
          this.countDownTimer()
        }, 1000)
      } else {
        this.$router.push('/')
      }
    }
  },
  mounted () {
    if (this.isCamera) this.countDown = 10
    this.countDownTimer()
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/base.scss";

.complete_wrap {
  height: 100vh;
  .content_wrap {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    @include flex-gap(8.75vh, row);
    height: 100vh;
    // padding: 27.5vh 4.6875vw 0;
    &.waiting-queue {
      // padding: 25vh 4.6875vw 0;
      .ticket_wrap {
        .ticket-title {
          color: $gray_800;
        }
      }
    }
  }
  .description_wrap {
    $description-gap: 3vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    @include flex-gap($description-gap, column);
    width: 44.532vw;
    .img_wrap {
      .img {
        width: 4.6875vw;
        height: 7.5vh;
        &.ticket {
          background: url("../assets/img/ticket.svg") no-repeat;
          background-size: contain;
        }
        &.camera {
          background: url("../assets/img/camera.svg") no-repeat;
          background-size: contain;
        }
        &.katalk {
          background: url("../assets/img/kakao.svg") no-repeat;
          background-size: contain;
        }
        &.email {
          background: url("../assets/img/email.svg") no-repeat;
          background-size: contain;
        }
        &.line {
          background: url("../assets/img/line.png") no-repeat;
          background-size: contain;
        }
      }
    }
    .title {
      color: $black;
      text-align: center;
      font-size: 40px; // IE11 fallback
      font-size: unquote("min(3.125vw, 40px)");
      font-weight: 700;
      line-height: 7.25vh;
    }
    .description {
      color: $gray_800;
      text-align: center;
      font-size: 26px; // IE11 fallback
      font-size: unquote("min(2.03125vw, 26px)");
      font-weight: 600;
      line-height: 4.75vh;
    }
    .go_home_button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50vh;
      height: 10vh;
      margin: 0;
      margin: calc(#{$description-gap} + 0.5vh) 0 0;
      border: 2px solid #B7BEC8;
      background: $white;
      box-sizing: border-box;
      border-radius: 16px;
      font-size: 26px; // IE11 fallback
      font-size: unquote("min(2.03125vw, 26px)");
      font-weight: 600;
      line-height: 4.75vh;
      color: #2E3137;
    }
  }
  .ticket_wrap {
    display: flex;
    width: 40.625vw;
    padding: 6.25vh 3.90625vw;
    flex-direction: column;
    align-items: center;
    @include flex-gap(3vh, column);
    border-radius: 4vh;
    border: 0.125vh solid #B7BEC8;
    background: #ECEEF0;
    text-align: center;
    font-size: 32px; // IE11 fallback
    font-size: unquote("min(2.5vw, 32px)");
    font-weight: 700;
    line-height: 4.75vh;
    color: $gray_800;
    .ticket-title {
      color: #D81B1B
    }
    .waiting-queue-name {
      word-break: break-all;
      color: #D81B1B;
    }
    .waiting-number {
      color: #D81B1B;
      font-size: 140px; // IE11 fallback
      font-size: unquote("min(10.9375vw, 140px)");
      font-weight: 800;
      line-height: 1;
    }
  }
  .timer_text {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 6.25vh 10.9375vw;
    color: $gray_800;
    font-size: 24px; // IE11 fallback
    font-size: unquote("min(1.875vw, 24px)");
    font-weight: 600;
    line-height: 4.75vh;
    text-align: center;
    cursor: pointer;
    user-select: none;
  }
}

/* .complete_wrap {
  display: flex;
  justify-content: space-between;
  width: 1280px;
  height: 800px;
  background: $gray_200;
  // padding: 104px 84px;
  box-sizing: border-box;
  transform-origin: top left;
  transform: scale(calc(100vw / 1280px), calc(100vh / 800px));

    .description_wrap {
      width: 632px;
      height: 800px;
      padding: 108px 0 104px 84px;
      .img_wrap {
        .img {
          width: 160px;
          height: 160px;
          margin: 0 auto;
          &.ticket {
            background: url("../assets/ticket.png") no-repeat;
            background-size: contain;
          }
          &.camera {
            background: url("../assets/camera.png") no-repeat;
            background-size: contain;
          }
          &.katalk {
            background: url("../assets/katalk.png") no-repeat;
            background-size: contain;
          }
          &.email {
            background: url("../assets/img/email_icon.svg") no-repeat;
            background-size: contain;
          }
        }
        .title {
          padding-top: 32px;
          text-align: center;
          color: $gray_900;
          font-size: 32px;
          font-weight: bold;
          margin-bottom: 32px;
          line-height: 1.5;
        }
      }
      .description {
        margin-bottom: 24px;
        padding: 24px;
        background: $gray_50;
        border-radius: 24px;
        color: $gray_900;
        font-size: 24px;
        line-height: 1.5;
        text-align: center;
        .orange {
          color: $orange;
        }
      }
      .go_home_button {
        border: 2px solid $gray_900;
        background: $white;
        box-sizing: border-box;
        border-radius: 16px;
        text-align: center;
        padding: 24px 0;
        font-size: 24px;
      }
      .timer_text {
        padding-top: 16px;
        color: $gray_600;
        font-size: 24px;
        text-align: center;
      }
    }
    .ticket_wrap {
      width: 640px;
      height: 800px;
      background: url("../assets/bill_background.svg") no-repeat;
      background-size: cover;
      .ticket-title {
        width: 500px;
        margin-left: 56px;
        padding-top: 162px;
        color: $black;
        font-size: 32px;
        line-height: 1;
        font-weight: bold;
        text-align: center;
      }
      .waiting-number-area {
        margin-left: 56px;
        width: 500px;
        padding-top: 217px;
        &.waiting-queue {
          padding-top: 100px;
        }
        .waiting-queue-name {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 116px;
          padding: 0 24px;
          word-break: break-all;
          color: $gray_900;
          font-size: 48px;
          line-height: 1.2;
          font-weight: 600;
          text-align: center;
        }
        .waiting-number {
          font-family: "Pretendard", -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", sans-serif;
          font-weight: 600;
          font-size: 120px;
          line-height: 1.2;
          color: $orange;
          text-align: center;
        }
      }
    }
 } */
</style>
